import { __rest, __assign } from 'tslib';
import React__default, { forwardRef } from 'react';
import { Button } from '@mui/material';
import clsx from 'clsx';

var KButton = forwardRef(function (_a, ref) {
    var className = _a.className, buttonName = _a.buttonName, _b = _a.testId, testId = _b === void 0 ? "KButtons" : _b, rest = __rest(_a, ["className", "buttonName", "testId"]);
    return (React__default.createElement(Button, __assign({ color: "primary", variant: "text", className: clsx("KButton", className, buttonName && "KButton-".concat(buttonName)), ref: ref }, rest, { "data-testid": testId })));
});

export { KButton as default };
//# sourceMappingURL=index.js.map
